@import '../styles/palette.scss';
@import '../styles/fonts.scss';

.endret {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin: 1em 0;
}

.notificationBadge {
  @include barlow(16);
  background: _palette(notification-badge);
  border-radius: 50%;
  color: _palette(bg-secondary);
  display: inherit;
  margin-left: 5px;
  margin-top: -2px;
  min-height: 24px;
  min-width: 28px;
  padding: 3px 5px;
}
